export default __webpack_public_path__ + "static/media/loginLandscape.51ca40af.svg";